import React from "react";
import { ShieldX } from "lucide-react";

interface AllowlistErrorDisplayProps {
  /** The error message from the Cognito Lambda (includes Slack channel info) */
  message: string;
}

/**
 * Displays a simple, clean error page when a user is denied access due to
 * not being in the TACO pilot LDAP group.
 */
export function AllowlistErrorDisplay({ message }: AllowlistErrorDisplayProps) {
  return (
    <div className="flex items-center justify-center min-h-screen bg-background">
      <div className="max-w-md w-full mx-4">
        <div className="bg-card border border-border rounded-lg p-8 shadow-lg text-center">
          <div className="flex justify-center mb-5">
            <ShieldX className="h-10 w-10 text-yellow-500" />
          </div>
          <h1 className="text-xl font-semibold mb-3 text-foreground">
            Access Restricted
          </h1>
          <p className="text-sm text-muted-foreground leading-relaxed">
            {message}
          </p>
        </div>
      </div>
    </div>
  );
}
